import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLiveAddress, getPlaybackAddress, getVideoListByTime } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 视频流地址
  liveAddress: {
    data: {},
    query: {}
  },
  // 回放视频流地址
  playbackAddress: {
    data: {},
    query: {}
  },
  // 按时间获取录像列表
  videoListByTime: {
    data: [],
    query: {}
  }
};

// 获取视频流地址
export const fetchLiveAddress = createAsyncThunk(
  'ys7Video/fetchLiveAddress',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getLiveAddress(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取视频流地址失败');
    }
  }
);

// 获取回放视频流地址
export const fetchPlaybackAddress = createAsyncThunk(
  'ys7Video/fetchPlaybackAddress',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getPlaybackAddress(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取回放视频流地址失败');
    }
  }
);

// 按时间获取录像列表
export const fetchVideoListByTime = createAsyncThunk(
  'ys7Video/fetchVideoListByTime',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getVideoListByTime(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取录像列表失败');
    }
  }
);

const videoSlice = createSlice({
  name: 'ys7Video',
  initialState: defaultState,
  reducers: {
    resetVideoState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchLiveAddress
      .addCase(fetchLiveAddress.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.liveAddress.query = action.meta.arg || {};
      })
      .addCase(fetchLiveAddress.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.liveAddress.data = action.payload?.data?.data || action.payload?.data || {};
        state.liveAddress.query = action.payload?.query || {};
      })
      .addCase(fetchLiveAddress.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.liveAddress.data = {};
      })

      // fetchPlaybackAddress
      .addCase(fetchPlaybackAddress.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.playbackAddress.query = action.meta.arg || {};
      })
      .addCase(fetchPlaybackAddress.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.playbackAddress.data = action.payload?.data?.data || action.payload?.data || {};
        state.playbackAddress.query = action.payload?.query || {};
      })
      .addCase(fetchPlaybackAddress.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.playbackAddress.data = {};
      })

      // fetchVideoListByTime
      .addCase(fetchVideoListByTime.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.videoListByTime.query = action.meta.arg || {};
      })
      .addCase(fetchVideoListByTime.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.videoListByTime.data = action.payload?.data?.data || action.payload?.data || [];
        state.videoListByTime.query = action.payload?.query || {};
      })
      .addCase(fetchVideoListByTime.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.videoListByTime.data = [];
      });
  }
});

export const { resetVideoState } = videoSlice.actions;
export default videoSlice.reducer;
